<header class="mobile-header">
  <div class="mobile-header-container">
    <app-info-banner />
    <app-logo />
    <app-search-bar [placeholder]="'common.form.placeholder.search_product' | translate" />
  </div>
</header>

